import { gql } from '@generated/gql';

const setApplication = gql(`
mutation SetApplication(
  $basketId: ID!,
  $accountHolders: [AccountHolderInput!],
  $correspondenceAddress: AddressInput,
  $recentlyMovedIn: Boolean
) {
  setApplication(
    application: {
      basketId: $basketId,
      accountHolders: $accountHolders,
      correspondenceAddress: $correspondenceAddress,
      recentlyMovedIn: $recentlyMovedIn
    }
  ) {
    id
    monthlyCost {
      currency
      value
    }
    depositRequirement {
      depositRequired
      depositAmount {
        currency
        value
      }
    }
  }
}
`);

const addPaymentMethod = gql(`
mutation AddPaymentMethod($paymentMethod: AddPaymentMethodInput!) {
  addPaymentMethod(paymentMethod: $paymentMethod) {
    directDebit {
      bankAccountToken
    }
  }
}
`);

const addSwitch = gql(`
  mutation AddSwitch($input: AddSwitchInput!) {
    addSwitch(input: $input)
  }
`);

const addSwitchingRequirements = gql(`
  mutation AddSwitchingRequirements($details: BroadbandUsageRequirementsInput!) {
    updateBroadbandQuoteRequirements(details: $details) {
      id
    }
  }
`);

const agentSendEeccContract = gql(`
  mutation AgentSendEECCContract($input: AgentSendEECCContractInput!) {
    agentSendEECCContract(input: $input)
  }
`);

const agentSendCbcTerms = gql(`
  mutation AgentSendCBCTerms($input: AgentSendCashbackCardTermsInput!) {
    agentSendCashbackCardTerms(input: $input)
  }
`);

const updateCbcRequirements = gql(`
  mutation UpdateCashbackCardQuoteRequirements($details: CashbackCardQuoteRequirementsInput!) {
    updateCashbackCardQuoteRequirements(details: $details) {
      id
    }
  }
`);

export {
  setApplication,
  addPaymentMethod,
  addSwitch,
  addSwitchingRequirements,
  agentSendEeccContract,
  agentSendCbcTerms,
  updateCbcRequirements,
};
